// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__AMzho","colCheckbox":"styles_colCheckbox__1aHY4"};